import React from 'react';
import useUser from 'sdk/hooks/user/useUser';
import useReports from 'sdk/hooks/useReports';
import Page from 'modules/app/components/Page';
import Preloader from 'components/shared/Preloader';
import styles from './Reports.module.scss';

function Reports() {
  const userData = useUser()
  const reportsData = useReports({ userId: userData?.data?.user?.id })
  // const { isAuth } = userData

  if (reportsData.isLoading) return (<Preloader />)

  return (
    <div className={styles.reports}>
      reports

      {(reportsData?.data || []).map((report: any) => (
        <div className={styles.report}>
          <div>
            created_at:
            {' '}
            <div className={styles.reportValue}>
              {report?.created_at}
            </div>
          </div>
          <div>
            {report?.type}
            {': '}
            <div className={styles.reportValue}>
              {report?.target}
            </div>
          </div>
          <div>
            reason:
            {' '}
            <div className={styles.reportValue}>
              {report?.text}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

function ReportsPage() {
  return (
    <Page activeLink="/reports">
      <Reports />
    </Page>
  )
}

export default ReportsPage
